'use client';

import React from 'react';

import ChartComponent1 from './ChartComponent1';
import ChartComponent2 from './ChartComponent2';
import ChartComponent3 from './ChartComponent3';

export default function OxxoChart() {
  return (
    <div className='flex flex-col gap-4 md:flex-row'>
      <div className='w-full md:w-1/3'>
        <ChartComponent1 />
      </div>
      <div className='w-full md:w-1/3'>
        <ChartComponent2 />
      </div>
      <div className='w-full md:w-1/3'>
        <ChartComponent3 />
      </div>
    </div>
  );
}
